import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-impressionen',
  templateUrl: './impressionen.component.html',
  styleUrls: ['./impressionen.component.scss']
})
export class ImpressionenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
